import axios from 'axios';

// Types
export const DATA_CHANGED = 'data_changed';
export const DATA_BATCH_CHANGED = 'data_batch_changed';
export const DATA_RESET = 'data_reset';

// Actions
export function setData(data, type) {
  return {
    type: DATA_CHANGED,
    payload: {
      type,
      data,
    },
  };
}

export function setDataBatch(data) {
  return {
    type: DATA_BATCH_CHANGED,
    payload: data,
  };
}

export function resetData() {
  return {
    type: DATA_RESET,
    payload: {},
  };
}

export function fetchPupils(successCallback, errorCallback) {
  return (dispatch) => {
    axios
      .get(`${window.apiUrl}/pupils`)
      .then((response) => {
        if (response.data.success) {
          dispatch(setData(response.data.data, 'pupils'));

          if (successCallback) {
            successCallback();
          }
        } else {
          if (errorCallback) {
            errorCallback(response.data.error);
          }
        }
      })
      .catch((thrown) => {});
  }
}
